import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container } from '@mui/material';
import { Route, Switch, withRouter } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@mui/material/Typography';
import withStyles from '@mui/styles/withStyles';

import Footer from './footer';
import Help from './help';
import PortalStepper from './portal-stepper';
import SignIn from './SignIn';
import TEALogoSvg from '../icons/tea-logo.svg';
import UnderMaintenance from './under-maintenance-page';

const styles = (theme) => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.background.default,
      overflowY: 'scroll',
    },
  },
  root: {
    // Will not work correctly in IE without 'block'
    display: 'block',
    transition: 'max-width 150ms ease-in',
  },
  logo: {
    height: 50,
    width: 'auto',
    margin: '24px 0',
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  card: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    transition: 'max-height 200ms ease-in',
  },
  cardContent: {
    padding: theme.spacing(3),
  },
  divider: {
    margin: theme.spacing(1, 0, 1),
  },
  barrier: {
    height: 100,
    width: 'auto',
    margin: '24px 0',
  },
});

class PaymentPortal extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
  };

  renderHeader = () => (
    <div>
      <Typography align="center" component="h1" variant="h4">
        Welcome to the Payment Portal
      </Typography>
    </div>
  );

  render() {
    const { classes, isAuthenticated } = this.props;

    const maxWidth = isAuthenticated ? 'sm' : 'xs';

    // Ease the transition to make page less jumpy
    const cardStyle = isAuthenticated
      ? { maxHeight: 2000 }
      : { maxHeight: 650 };

    const showConstructionPage =
      process.env.REACT_APP_SHOW_CONSTRUCTION_PAGE || 'false';

    return (
      <Container className={classes.root} component="main" maxWidth={maxWidth}>
        {/* {this.renderHeader()} */}
        <Card className={classes.card} elevation={2} style={cardStyle}>
          <CardContent className={classes.cardContent}>
            <div className={classes.header}>
              <TEALogoSvg className={classes.logo} />
            </div>
            {showConstructionPage === 'false' && (
              <Switch>
                {/* TODO: add loading indicator when invoiceid is in URL */}
                {/* <Route path="/invoice/:invoiceId/:paymentCode" component={PortalStepper} /> */}
                <Route component={PortalStepper} path="/invoice" />
                <Route component={SignIn} />
              </Switch>
            )}
            {/* Show under maintenance message in case its needed */}
            {showConstructionPage === 'true' && <UnderMaintenance />}
          </CardContent>
          <Divider className={classes.divider} />
          <Help />
        </Card>
        <Footer />
      </Container>
    );
  }
}

function mapStateToProps(state) {
  const { step } = state;

  return {
    isAuthenticated: step.isSignInComplete,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(PaymentPortal))
);
